import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { AttendeeFields } from '@/types/all-attendees.types';

export const setAllAttendeesFields = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<AttendeeFields>((state, action) => {
    state.allAttendees.fields = action.payload;
    state.allAttendees.page = 1;
  });
